import script from "./AppNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotifications.vue?vue&type=style&index=0&id=f10d4d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f10d4d70"]])

export default __exports__